module.exports = __webpack_public_path__ + "f83ae0ff14649699c17a48486239cbfd.png";